var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"attributes",rawName:"v-attributes",value:(_vm.schema.attributes),expression:"schema.attributes"}],staticClass:"field-undefined"},[_vm._v(" "+_vm._s(_vm.i18n.field_not_configured)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }